'use client';

import useDeviceType from "@/hooks/useDeviceType";
import { useEffect } from "react";

export interface ImageAsset {
  mobile?: {
    url: string;
    aspectRatio: number;
    orientation: 'portrait' | 'landscape';
  };
  tablet?: {
    url: string;
    aspectRatio: number;
    orientation: 'portrait' | 'landscape';
  };
  desktop?: {
    url: string;
    aspectRatio: number;
    orientation: 'portrait' | 'landscape';
  };
  caption?: string;
}

export interface ImageFigureProps {
  image: ImageAsset;
  alt?: string;
  className?: string;
}

const ImageFigure = ({ image, alt = 'Image', className = '' }: ImageFigureProps) => {
  if (!image.mobile) {
    return null;
  }

  const device = useDeviceType();
  const deviceImage = image[device] || image.mobile;
  const porraitWidth = {
    mobile: '100%',
    tablet: '70%',
    desktop: '60%',
  };

  return (
    <figure className={className}>
      <picture style={{ width: deviceImage.orientation === 'portrait' ? porraitWidth[device] : '100%', height: 'auto', margin: '0 auto' }}>
        {image.desktop && (
          <source media="(min-width: 1024px)" srcSet={image.desktop.url} />
        )}
        {image.tablet && (
          <source media="(min-width: 768px)" srcSet={image.tablet.url} />
        )}
        <img
          src={image.mobile.url}
          alt={alt}
          style={{ width: '100%', height: 'auto', margin: '0 auto' }}
        />
        {image.caption && (
          <figcaption className="caption">
            {image.caption}
          </figcaption>
        )}
      </picture>
    </figure>
  )
};

export default ImageFigure;